/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FuelControllerPumpAuthorizeConfirmationApiModel } from './fuel-controller-pump-authorize-confirmation';
import { FuelPumpRecApiModel } from './fuel-pump-rec';
import { FuelControllerConfigurationApiModel } from './fuel-controller-configuration';
import { FuelFillingTypeApiModel } from './fuel-filling-type';

export interface FuelRecApiModel {
  configuration?: FuelControllerConfigurationApiModel;
  /**
   * Configuration reading status (read only)
   */
  configuration_reading_status?: FuelRecApiModelConfigurationReadingStatusEnum;
  /**
   * Controller configuration last updated time
   */
  configuration_updated?: string;
  /**
   * Controller ID
   */
  id?: string;
  pump_authorize_confirmation?: FuelControllerPumpAuthorizeConfirmationApiModel;
  pump_authorize_type?: FuelFillingTypeApiModel;
  /**
   * Pumps info
   */
  pumps?: Array<FuelPumpRecApiModel>;
  /**
   * Skip pumps when selecting fuel for filling
   */
  skip_pumps_in_selection?: number;
}
export enum FuelRecApiModelConfigurationReadingStatusEnum {
  ConnectionNotConfigured = 'connection-not-configured',
  ReadyToRead = 'ready-to-read',
  Success = 'success',
  Fail = 'fail'
}
